import { useState } from 'react'
import './DeleteAgentConfirmation.css'

interface DeleteAgentConfirmationProps {
  agentId: string
  onConfirm: () => void
}

function DeleteAgentConfirmation({ agentId, onConfirm }: DeleteAgentConfirmationProps) {
  const [showConfirm, setShowConfirm] = useState(false)

  function handleConfirm() {
    onConfirm()
    setShowConfirm(false)
  }

  return (
    <div className="delete-agent-wrapper">
      <button
        data-testid={`delete-agent-${agentId}`}
        className="delete-agent-btn"
        onClick={() => setShowConfirm(!showConfirm)}
        title="Delete Agent"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 4h12M5.33 4V2.67a1.33 1.33 0 011.34-1.34h2.66a1.33 1.33 0 011.34 1.34V4M12.67 4v9.33a1.33 1.33 0 01-1.34 1.34H4.67a1.33 1.33 0 01-1.34-1.34V4" /></svg>
      </button>
      {showConfirm && (
        <div data-testid={`delete-agent-confirm-${agentId}`} className="delete-agent-popover">
          <div className="delete-agent-popover-title">Delete Agent (Confirmation Required)</div>
          <div className="delete-agent-popover-actions">
            <button
              data-testid={`confirm-delete-agent-${agentId}`}
              className="delete-agent-confirm-yes"
              onClick={handleConfirm}
            >
              Delete
            </button>
            <button
              data-testid={`cancel-delete-agent-${agentId}`}
              className="delete-agent-confirm-no"
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default DeleteAgentConfirmation
